<template>
  <DragPanel
    :title="getPanelTitle()"
    :closePanel="closePanel"
    :tooltipVisible="false">
    <div class="gis-setting-box">
      <div class="label-box">
        <div class="label dialog-label">显示优先级调整</div>
        <el-tooltip
          :effect="$theme.tooltipKey()"
          placement="top-start"
          popper-class="common-panel-tooltip-box">
          <div slot="content">
            注：WMTS与遥感影像共用一套优先级排序系统，并规定所有遥感影像的显示优先级在WMTS之上,
            在同一排序系统中按照加入场景的时间倒序显示，越靠后添加，优先级越高
          </div>
          <div class="icon-box">
            <icon-svg
              icon-class="ic-jieshishuoming"
              class="icon" />：
          </div>
        </el-tooltip>
      </div>
      <div class="priority-setting-box">
        <div class="layer-list-box">
          <div
            class="layer-item-box"
            v-for="(item, index) in layerList"
            :key="index">
            <div
              class="text-overflow"
              :title="item.name">
              {{ item.name }}
            </div>
            <div class="common-button-box">
              <el-button
                type="text"
                size="small"
                title="上移"
                :disabled="index === 0"
                @click="moveLayer(item, true)">
                <icon-svg
                  icon-class="ic-shengxu"
                  class="icon" />
              </el-button>
              <el-button
                type="text"
                size="small"
                title="下移"
                :disabled="index === layerList.length - 1"
                @click="moveLayer(item, false)">
                <icon-svg
                  icon-class="ic-jiangxu"
                  class="icon" />
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="operation-btn-box">
      <el-button
        size="small"
        class="normal-ang-btn gr8 hollowOut-btn"
        @click="closePanel">
        取消
      </el-button>
      <el-button
        size="small"
        type="primary"
        class="primary-btn primary-ang-btn"
        @click="submit">
        确定
      </el-button>
    </div>
  </DragPanel>
</template>

<script>
import DragPanel from '@/components/CustomDragPanel.vue'

import {
  getGisPriorityListService,
  updateGisPriorityListService
} from '@/service/interface'

export default {
  data() {
    return {
      originPriorityList: [],
      layerList: []
    }
  },
  props: {
    gisInfo: Object,
    updateSceneTree: Function,
    setUnitLayerLevel: Function,
    updateUnitLayerLevelByLayerList: Function,
    closePrioritySettingPanel: Function
  },
  components: { DragPanel },
  mounted() {
    this.initPriorityList()
  },
  methods: {
    initPriorityList() {
      let gisInfo = this.gisInfo
      let nodeId = gisInfo.sceneNodeId
      getGisPriorityListService(nodeId).then(response => {
        if (response.isSuccess) {
          let data = response.data
          this.originPriorityList = JSON.parse(JSON.stringify(data))

          this.layerList = data
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    moveLayer(layerInfo, isUpMove) {
      let findIndex = this.layerList.findIndex(
        el => el.treeNodeId === layerInfo.treeNodeId
      )
      let elementToMove = this.layerList[findIndex]
      this.layerList.splice(findIndex, 1)

      // 再将元素插入到新的位置
      if (isUpMove) {
        this.layerList.splice(findIndex - 1, 0, elementToMove)
      } else {
        this.layerList.splice(findIndex + 1, 0, elementToMove)
      }

      this.updateUnitLayerLevelByLayerList(this.layerList)
    },
    submit() {
      let priorityList = this.layerList.map(item => {
        let obj = { treeNodeId: item.treeNodeId }
        return obj
      })
      updateGisPriorityListService({ priorityList }).then(response => {
        if (response.isSuccess) {
          let originPriorityList = JSON.parse(JSON.stringify(this.layerList))
          this.originPriorityList = originPriorityList

          this.updateSceneTree().then(() => {
            this.closePanel()

            this.$message.success('设置成功')
          })
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    getPanelTitle() {
      let levelPathName = this.gisInfo.levelPathName
      let dataSetType = levelPathName.split('/')[0]
      return `${dataSetType}设置`
    },
    closePanel() {
      this.updateUnitLayerLevelByLayerList(this.originPriorityList)
      this.closePrioritySettingPanel()
    },
    // 打开其他面板前给出提示
    openOtherPanelCheck() {
      return new Promise(resolve => {
        let levelPathName = this.gisInfo.levelPathName
        let dataSetType = levelPathName.split('/')[0]

        // prettier-ignore
        let message = `正在调整${dataSetType}设置，请结束后再执行相关操作`;
        let options = {
          message,
          type: 'warning',
          duration: 5000,
          showClose: true
        }
        this.$message(options)
        resolve(false)
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.common-drag-panel {
  left: 6px;
  top: 6px;
  width: 360px;
  height: 300px;
  min-width: 360px;
  min-height: 300px;

  /deep/ .content {
    display: flex;
    flex-direction: column;
    height: calc(100% - 40px);

    .gis-setting-box {
      flex-grow: 1;
      padding: 15px;
      font-size: 14px;
      color: var(--default-color);

      .label-box {
        display: flex;
        align-items: center;

        .icon-box {
          display: flex;
          align-items: center;
          margin-left: 4px;
        }

        .icon {
          margin-right: 2px;
        }
      }

      .priority-setting-box {
        margin-top: 15px;
        border-radius: 8px;
        background-color: var(--scene-edit-setting-bgColor);
        border: 1px solid var(--scene-edit-setting-border-color);

        .layer-list-box {
          color: var(--default-color);
          padding: 10px;
          height: 120px;
          overflow-y: auto;

          .layer-item-box {
            display: flex;
            justify-content: space-between;
            padding: 0px 8px;
            border-radius: 4px;
            line-height: 32px;

            &:hover {
              background: var(--scene-edit-setting-item-hover-color);

              .common-button-box {
                display: block;

                .el-button--small {
                  padding: 5px 0px;
                }
              }
            }

            .common-button-box {
              display: none;
              .icon {
                color: var(--icon-dark-color);
              }
            }
          }
        }
      }
    }

    .operation-btn-box {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 14px 16px;
      border-top: 1px solid var(--dialog-split-line-color);
    }
  }
}
</style>
